export const i18n = {
    defaultLocale: 'en',
    locales: ['en', 'ua'],
  } as const

export type Locale = (typeof i18n)['locales'][number]

// Locale display names mapping
export const localeNames: Record<Locale, string> = {
  en: 'English',
  ua: 'Українська'
}

// Locale information with additional details
export const localeInfo: Record<Locale, {
  name: string;
  nativeName: string;
  flag: string;
}> = {
  en: {
    name: 'English',
    nativeName: 'English',
    flag: '🇬🇧'
  },
  ua: {
    name: 'Ukrainian',
    nativeName: 'Українська',
    flag: '🇺🇦'
  }
}



// Get locale display name by code
export const getLocaleName = (locale: Locale): string => {
  return localeNames[locale] || locale.toUpperCase()
}

// Get full locale information
export const getLocaleInfo = (locale: Locale) => {
  return localeInfo[locale] || {
    name: locale.toUpperCase(),
    nativeName: locale.toUpperCase(),
    flag: '🏳️'
  }
}

// Get flag for a specific locale
export const getFlag = (locale: Locale): string => {
  return localeInfo[locale]?.flag || '🏳️'
}